<template>
    <button class="btn-btn" :name="name" :disabled="isDisabled" @click="$emit('click')" :style="style">
        <loading-animation v-if="loading"></loading-animation>
        <slot v-else></slot>
    </button>
</template>

<script>
    import LoadingAnimation from './LoadingAnimation'
    export default {
        name: "Btn",
        props: {
            disabled: {
                default: false,
            },
            loading: {
                default: false,
            },
            name: {
                default: false,
            }
        },
        computed: {
            isDisabled() {
                return this.disabled || this.loading;
            },
            style() {
                if (this.isDisabled) {
                    return {
                        'background-color': 'transparent !important',
                    }
                }

                return {};
            }
        },
        components: {
            LoadingAnimation
        }
    }
</script>

<style scoped>
</style>